package com.kelimesoft.etutpro.viewmodels

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers

open class BaseVM {
    val scope: CoroutineScope = CoroutineScope(Dispatchers.Default)
}